module.exports = __webpack_public_path__ + "img/help_center.0bec5545.png";